import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem.js'
import 'normalize.css/normalize.css';
import { Form, Field, CellGroup, Button, Toast, Overlay, RadioGroup, Radio, Dialog, Pagination,Checkbox, CheckboxGroup , PickerGroup, Popup, DatePicker, Cell } from 'vant';
import 'vant/lib/index.css';
import moment from 'moment';

// import VueQrcodeReader from 'vue-qrcode-reader'

// import VueBarcodeScanner from 'vue-barcode-scanner';



const app = createApp(App)
// app.use(VueQrcodeReader)
// app.use(VueBarcodeScanner)
moment.locale('zh-cn');
app.config.globalProperties.$moment = moment
app.use(store).use(router).mount('#app')
app.use(Form);
app.use(Field);
app.use(CellGroup);
app.use(Button);
app.use(Toast);
app.use(Overlay);
app.use(Radio);
app.use(RadioGroup);
app.use(Dialog);
app.use(Pagination);
app.use(Checkbox);
app.use(CheckboxGroup);
app.use(PickerGroup);
app.use(Popup);
app.use(DatePicker);
app.use(Cell);

